import { slide as Menu } from 'react-burger-menu'

function HamburgerMenu({schema}) {

    return (
        <Menu>
          {
            schema.screenContent.header.menuItems.map((item, index) => {
              return(
                <a key={index} className="menu-item" href={item.link} target="_blank" rel="noreferrer">{item.menuItem}</a>
              )
            })
          }
          <a className="menu-item" href={schema.screenContent.header.contact.address} target="_blank" rel="noreferrer">{schema.screenContent.header.contact.contactTitle}</a>
      </Menu>
    );
}
export default HamburgerMenu